<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <div class="row">
            <div class="col-12 table-container">
              <data-table
                v-model="table"
                :get-page="getPage"
                :has-details-row="false"
                :per-page="250"
                :selectable-rows="false"
              >
                <template #head(company)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.company"
                    input-type="number"
                  />
                </template>
                <template #head(stock)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.stock"
                    input-type="number"
                  />
                </template>
                <template #head(articleId)="row">
                  {{ row.label }}
                  <table-filter v-model="table.filter.articleId" />
                </template>
                <template #head(unitsInStock)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.unitsInStock"
                    input-type="number"
                  />
                </template>
                <template #head(unitsOrdered)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.unitsOrdered"
                    input-type="number"
                  />
                </template>
                <template #head(unitsReserved)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.unitsReserved"
                    input-type="number"
                  />
                </template>
                <template #head(primaryKey)="row">
                  {{ row.label }}
                  <table-filter v-model="table.filter.primaryKey" />
                </template>
              </data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { StockMixin, NotificationMixin } from '../../../mixins';
import PageHeader from '../../structure/page-header';
import TableFilter from '../../table/table-filter';

export default {
  name: 'Stocks',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [StockMixin, NotificationMixin],
  data: function() {
    return {
      table: {
        rows: [],
        fields: [
          { key: 'company', label: this.$translate('company') },
          { key: 'stock', label: this.$translate('stock') },
          { key: 'articleId', label: this.$translate('article') },
          { key: 'unitsInStock', label: this.$translate('units_in_stock') },
          { key: 'unitsOrdered', label: this.$translate('units_ordered') },
          { key: 'unitsReserved', label: this.$translate('units_reserved') },
          { key: 'primaryKey', label: this.$translate('primary_key') },
        ],
        filter: {
          company: null,
          stock: null,
          articleId: null,
          unitsInStock: null,
          unitsOrdered: null,
          unitsReserved: null,
          primaryKey: null,
        },
      },
    };
  },
  methods: {
    async getPage(params) {
      try {
        const response = await this.stockService.getPage(params);
        return { totalCount: response.totalCount, data: response.stocks };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep   .b-table-sticky-header {
  max-height: calc(100vh - 230px);
  min-height: calc(100vh - 230px);
}

::v-deep   .table {
  min-width: 900px;
}

// @media (max-width: 991px) {
//   .main-content {
//     max-height: calc(100vh - 100px);
//   }
// }
</style>
